import { render, staticRenderFns } from "./ResetLegalPwd.vue?vue&type=template&id=2f0bb47c"
import script from "./ResetLegalPwd.vue?vue&type=script&lang=js"
export * from "./ResetLegalPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports